import {
  Box,
  Button,
  Flex,
  HStack,
  SimpleGrid,
  Stack,
  Text,
} from "@chakra-ui/react";
import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";
import { FormattedMessage } from "react-intl";
import { CenteredContent } from "../CenteredContent";
import { Href } from "../Href";
import { Icon } from "../Icon";
import { MapSvg } from "./MapSvg";

export function InterventionAreas() {
  return (
    <Box background="brandPrimary.700" padding="3rem .625rem">
      <CenteredContent>
        <SimpleGrid
          templateColumns={{ base: "1fr", md: "45% 53%" }}
          gap="1.5rem"
          flexDir={{ base: "column", md: "row" }}>
          <Flex flexDir="column">
            <Stack spacing={{ base: "1rem", md: "0" }}>
              <Text variant="h1" color="white">
                <FormattedMessage defaultMessage="Nos secteurs d'intervention" />
              </Text>

              <Text variant="h2" color="white">
                <FormattedMessage defaultMessage="Dans le Grand Est et à nos antennes" />
              </Text>
            </Stack>

            <Stack spacing="1.5rem" margin={{ base: "1.5rem 0", md: "auto 0" }}>
              <Text variant="h4" color="white">
                <FormattedMessage
                  defaultMessage="Nos experts sont présents dans 17 départements
et dans les secteurs autour de nos antennes."
                />
              </Text>

              <Text variant="h4" color="white">
                <FormattedMessage
                  defaultMessage="Nous sommes également mobilisés sur l’ensemble
du territoire français pour intervenir dans le cadre
de sinistres industriels majeurs ou catastrophes naturelles."
                />
              </Text>

              <Box>
                <Href href={generateFrontPath({ id: "@front.references" })}>
                  <Button
                    colorScheme="gray"
                    h="52px"
                    variant="outline"
                    _hover={{ color: "brandPrimary.700", bg: "white" }}
                    color="white">
                    <FormattedMessage defaultMessage="Voir nos références" />
                  </Button>
                </Href>
              </Box>
            </Stack>
          </Flex>

          <Box position="relative">
            <MapSvg />

            <Stack
              spacing="1rem"
              position={{ base: "initial", md: "absolute" }}
              marginTop={{ base: "1.5rem", md: "0" }}
              bottom="0"
              left="0">
              <HStack alignItems="center">
                <Icon icon="ms_circle" color="white" />

                <Text color="white">
                  <FormattedMessage defaultMessage="Siège social à Ban de Laveline" />
                </Text>
              </HStack>

              <HStack alignItems="center">
                <Box bgColor="white" w="12px" h="12px" borderRadius="50%" />

                <Text color="white">
                  <FormattedMessage defaultMessage="Nos antennes" />
                </Text>
              </HStack>

              <HStack alignItems="center">
                <Box
                  bgColor="brandPrimary.500"
                  w="16px"
                  h="16px"
                  borderRadius="2px"
                />

                <Text color="white">
                  <FormattedMessage defaultMessage="Nos zones d'intervention" />
                </Text>
              </HStack>
            </Stack>
          </Box>
        </SimpleGrid>
      </CenteredContent>
    </Box>
  );
}
